import React, { useEffect } from 'react';
import Header from '../Header/Header';
import { TickerModel } from './Tickermodel';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsXrange from 'highcharts/modules/xrange';
import { WatchModel } from '../Watchlist/WatchlistModel';

const Ticker = () => {
    const tickerModel = TickerModel();
    const watchModel = WatchModel();

    // const options = {
    //     chart: {
    //         type: 'candlestick'
    //       },
    //       title: {
    //         text: 'Hollow Candlestick Chart'
    //       },
    //       series: [{
    //         type: 'candlestick',
    //         name: 'AAPL',
    //         data: [
    //           [1, 90, 95, 75, 85],
    //           [2, 80, 85, 70, 75],
    //           // Add your data here
    //         ]
    //       }]
    //   }

    return (
        <>
            <Header />
            <div className="container mt-5">
                <div className="row mt-5">
                    <div className="col-md-12 mt-5">
                        <h1>Ticker details</h1>

                        <HighchartsReact
                            highcharts={Highcharts}
                            options={tickerModel.tickerdata} />

                    </div>

                    <div className="col-md-12">
                        {
                            tickerModel.lstPosts && tickerModel.lstPosts.map((d: any, index: number) => (
                                <div key={index}>
                                    <div className="card">
                                        <div className="card-body p-13">
                                            <div className="row border-bottom_card">
                                                <div className="col-8">
                                                    <div className="d-flex align-items-center mb-2">
                                                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                            <img src={tickerModel.imagePath + d.UserImage} alt="Profile" className="rounded-circle rounded-circle-image w-100" />
                                                        </div>
                                                        <div className="ps-3 my-auto">
                                                            <h6 className="fw-600 mb-0 fs-17 pe-1 title-color d-flex">{d.UserName}
                                                                <span className="verified-tick d-flex justify-content-center ms-1"><i className="bi bi-check-lg fs-12"></i></span>
                                                            </h6>
                                                            <p className="date-time fs-12  m-0">{d.CreatedDate}</p>
                                                        </div>

                                                    </div>

                                                </div>
                                                <div className="col-4 my-auto">
                                                    {d.Type == 'Chart' ? <p className="float-end rounded-circle bg-color_ct padding-cus1"><span className="fs-13 fw-600 d-flex">C</span></p> : ''}
                                                    {d.Type == 'Catalyst' ? <p className="float-end rounded-circle bg-color_ct padding-cus1"><span className="fs-13 fw-600 d-flex">CT</span></p> : ''}
                                                    {d.Type == 'Twit' ? <p className="float-end rounded-circle bg-color_ct padding-cus1"><span className="fs-13 fw-600 d-flex">T</span></p> : ''}
                                                </div>

                                            </div>
                                            <div className="row">
                                                <div className="col-8">
                                                    <div className="d-flex align-items-center mb-2">

                                                        <div className="ps-1 mt-2">
                                                            <h6 className="mb-0 fs-13 pe-1 title-color d-flex mb-1">{d.Ticker}</h6>
                                                            <p className="date-time fs-13">{d.Message}</p>
                                                        </div>

                                                    </div>

                                                </div>
                                                <div className="col-4">
                                                    <p className="float-end fs-13 date mt-2">Target days ({d.Period})</p>
                                                </div>

                                                <div className="col-3 col-md-3 p-0">
                                                    <p className="date-time fs-13 mb-0">Stop Loss</p>
                                                    <p className="date fs-13 mb-0">{d.Exit}</p>
                                                </div>
                                                <div className="col-3 col-md-3 p-0">
                                                    <p className="date-time fs-13 mb-0">Entry Price</p>
                                                    <p className="date fs-13 mb-0">{d.Entry}</p>
                                                </div>
                                                <div className="col-3 col-md-3 p-0">
                                                    <p className="date-time fs-13 mb-0">Target Price</p>
                                                    <p className="date fs-13 mb-0">{d.Target}</p>
                                                </div>
                                                <div className="col-3 col-md-3 p-0">
                                                    <p className="date fs-13 mb-0">{watchModel.getLastPriceByTicker(d.Ticker, 'lastSale')}</p>

                                                    {watchModel.getLastPriceByTicker(d.Ticker, 'netChange') < 0 ?
                                                        <p className="date-time fs-13 mb-3 color_percent" >
                                                            {watchModel.getLastPriceByTicker(d.Ticker, 'netChange')}
                                                            ({watchModel.getLastPriceByTicker(d.Ticker, 'pctChange')})
                                                        </p>
                                                        :

                                                        <p className="date-time fs-13 mb-3 text-color " >
                                                            {watchModel.getLastPriceByTicker(d.Ticker, 'netChange')}
                                                            ({watchModel.getLastPriceByTicker(d.Ticker, 'pctChange')})
                                                        </p>

                                                    }



                                                </div>

                                                <div className="col-12 text-center p-0">
                                                    <img src={tickerModel.imagePath + d.ImageName} alt="charts twits" />
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="row">
                                                        <div className="col-4 pt-2 text-start">
                                                            {
                                                                d.Liked == 1 ?
                                                                    <a onClick={(e) => tickerModel.reactionClick(d, 'like')} className="px-2 date-time fs-18 text-danger"><i className="bi bi-heart-fill"></i></a>
                                                                    :
                                                                    <a onClick={(e) => tickerModel.reactionClick(d, 'like')} className="px-2 date-time fs-18"><i className="bi bi-heart"></i></a>
                                                            }


                                                            <a href="" className="date-time fs-18 px-3"><i className="bi bi-share"></i></a>

                                                        </div>

                                                        <div className="col-8 text-end pt-2">
                                                            <p className="date-time fs-13" data-bs-toggle="modal" data-bs-target="#commentPopup" onClick={(e) => tickerModel.addComment(d)}>Add / View comment <span><i className="bi bi-plus-circle"></i></span></p>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default Ticker;